import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/regulationSystem/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/regulationSystem/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/regulationSystem/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/regulationSystem/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/regulationSystem/submit', params, options);

export const getTreeChildrenPowerNode = (params, options) =>
  request.get(
    '/api/v4ward/regulationSystem/treeChildrenPowerNode',
    Object.assign({}, options, { params })
  );
